import React from "react";
import {RowContext, TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {
    getFeConfig,
    visualize,
    notificationSubscribers,
    submitNotificationSubscribers,
    insertNotificationSubscribers
} from "../api/api";
import {Button, Space, Modal, notification} from "antd";
import {AppstoreAddOutlined, EyeOutlined} from '@ant-design/icons'
import Checkbox from "antd/es/checkbox/Checkbox";
import {Form} from "@q4us-sw/q4us-ui";
import TableDataSource from "../utils/TableDataSource";

export const AssignedNotifications = ({user}) => {
    return <div className={`notification_subscription`}>
        <TableV2
            schema = {'notification_types'}
            fetchConfig={async (schema) => {
                const {data: {rows = []} = {}} = await getFeConfig(schema) || {}
                return { data: { statusCode : 200, rows: rows } };
            }}
            fetchData={async () => {
                const {email} = user
                const {data: {rows}} = await notificationSubscribers(email)
                const {data: {rows: error_types}} = await visualize('eas_error_notification_types') || {}
                const Data = []
                for (const error_type of error_types) {
                    const name = error_type.error_type;
                    Data.push({
                        "description": error_type.description,
                        "notification_type": error_type.notification_type,
                        "notify": rows[0] ? rows[0][`${name}`] : false,
                        "error_type": error_type.error_type
                    })
                }
                return {data: {rows: Data, statusCode: 200}}
            }}

            scroll={{y: '100vh', x: 'max-content'}}
            customRenderer={{
                notify: (value, row)=>{
                    const onChange = async (e) => {
                        const obj: any  = {}
                        const rowName = row.error_type
                        obj[`${rowName}`] = e.target.checked
                        await submitNotificationSubscribers(obj, user);
                    };
                    return [
                        <Checkbox onChange={onChange} defaultChecked={row.notify}/>
                    ]
                },
            }}
        >
        </TableV2>
    </div>
}

const Header = () => {
    const [open, setOpen] = React.useState(false);
    return <React.Fragment>
        <div style={{ textAlign: 'right' , margin: 20}} >
            <Space>
                <Button style={{ width: 160 }} icon={<AppstoreAddOutlined />} onClick={() => setOpen(true)}>Add New Record</Button>
            </Space>
        </div>

        <Modal
            centered
            closable={true}
            onCancel={() => setOpen(false)}
            footer={null}
            title={`Add new Record`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={'notification_subscribers'} config={async () => {
                const res = await getFeConfig('notification_subscribers') || {}
                const { data: { rows = [] } = {} } = res;
                return rows.filter(({ generated }) => !generated).sort(({ sequence_no: a }, { sequence_no: b }) => { return a - b });

            }}

                  submit={async (values) => {
                      const { data } = await insertNotificationSubscribers(values);
                      if (data.statusCode === 200) {
                          notification.success({ message: `New record added to Notification Subscribers` })
                      }
                      return true;
                  }} />
        </Modal>

        </React.Fragment>
}

export const NotificationSubscribers = () => {

    const [setOpen] = React.useState(false)
    const [source, setSource] = React.useState(new TableDataSource());

    return <TableV2
        header={Header()}
        fetchConfig={async (schema) => {
            return await getFeConfig(schema)
        }}
        fetchData={async () => {
            return await visualize("notification_subscribers");
        }}

        saveData={async (data) => {
            const { data: { statusCode = 400, rows = [] } = {} } = await insertNotificationSubscribers(data);
            return { data: { statusCode, rows: [data] } };
        }}

        editable={true}

        source={source}

        schema={"notification_subscribers"}

        action={{
            name: 'id',
            title: 'Assign Notification',
            options: TableOperation.Custom
        }}

        getCustomAction={() => {
            return [
                <RowContext.Consumer>
                    {row => <Space>
                        <Button icon={<EyeOutlined/>} onClick={async () =>{
                            Modal.info({
                                title: `Assign Notification Types`,
                                content: <React.Fragment>
                                    <AssignedNotifications onCancel={()=>setOpen(false)} onSubmit={()=> {
                                        setOpen(false)
                                        return true;
                                    }} user={ row.row}
                                    />
                                </React.Fragment>,

                                okType: "ghost",
                                okText: "Close",
                                maskClosable: true,
                                closable: true,
                                keyboard: true,
                                bodyStyle: {overflowX: 'scroll', overflowY: 'scroll', width: 'fit-content', height: '60vh', maxWidth: '75vw'},
                                width: 'fit-content'
                            })
                        }}/>
                    </Space>}
                </RowContext.Consumer>

            ]
        }}
    >
    </TableV2>
}
